module.exports = __webpack_public_path__ + "static/media/gif_SE_step_3.16f47ea1.gif";